/**
 * Admin Login – for IGF SuperAdmin only. Calls POST /api/admin/login.
 * On success: store token, redirect to /admin/dashboard.
 */
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import hrApi from './api';
import './css/Login.css';

function AdminLogin() {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setIsSubmitting(true);
    try {
      const res = await hrApi.post('/api/admin/login', formData);
      const token = res.data.token;
      if (!token) {
        setMessage('Login failed: no token received');
        setIsSubmitting(false);
        return;
      }
      localStorage.setItem('token', token);
      navigate('/admin/dashboard', { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.message || err?.response?.data?.msg || 'Invalid credentials';
      setMessage(msg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page bk-img">
      <div className="form-content">
        <div className="container">
          <div className="row d-flex align-items-center justify-content-center vh-100">
            <div className="col-md-6 login-box">
              <h1 className="text-center pt-2x">
                <img src="/images/logo.png" width="150" alt="IGF" />
              </h1>
              <p className="text-center text-bold mb-0" style={{ fontSize: '1.25rem', color: '#00573C' }}>
                IGF Staff Portal
              </p>
              <h2 className="text-center text-bold mt-2" style={{ fontSize: '1.35rem', color: '#333' }}>
                Admin Login
              </h2>
              <div className="well row pt-2x pb-3x bk-light">
                <div className="col-md-10 offset-md-1">
                  <form onSubmit={handleSubmit}>
                    <div className="form-group mb-3">
                      <label>Email address</label>
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Enter your email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group mb-3 position-relative password-wrapper">
                      <label>Password</label>
                      <input
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        className="form-control pe-5"
                        placeholder="Enter your password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />
                      <i
                        className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}
                        onClick={() => setShowPassword(!showPassword)}
                        aria-hidden="true"
                      />
                    </div>
                    <button
                      type="submit"
                      className="btn btn-warning btn-block mt-3 w-100"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Logging in...' : 'Login'}
                    </button>
                    {message && (
                      <div className="alert mt-3 mb-0 alert-danger">{message}</div>
                    )}
                  </form>
                  <p className="mt-3 mb-0 text-center">
                    <Link to="/login">Staff user login</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
